import { Box } from '@mui/material';
import { KpiCard } from './KpiCard';
import * as kpiState from '../../state';
import { useGetLogEntryCardsQuery, SectionUnitsEnum, LogCategory } from '@/__generated__/graphql';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { getIconNode } from './utils';
import { COLLECTION_NAMES } from '@/constants';
import * as globalState from '@/components/Analysis/state';

export const KpiCards = () => {
  const selectedDeploymentIds = useAtomValue(kpiState.selectedDeploymentIds);
  const unitSystem = useAtomValue(globalState.unitSystem);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const selectedStartDate = useAtomValue(kpiState.selectedStartDate);
  const selectedEndDate = useAtomValue(kpiState.selectedEndDate);

  const startDate = selectedStartDate
    ? new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(selectedStartDate)
    : undefined;

  const endDate = selectedEndDate
    ? new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(selectedEndDate)
    : undefined;

  const { data } = useGetLogEntryCardsQuery({
    variables: {
      input: {
        structureIds: selectedDeploymentIds,
        timezone: userTimezone,
        startDate: startDate,
        endDate: endDate,
        collectionName: COLLECTION_NAMES.WORKPACK,
        category: [LogCategory.Worklog],
      },
    },
    skip: !selectedDeploymentIds.length,
  });

  const cards = useMemo(() => data?.getLogEntryCards ?? [], [data?.getLogEntryCards]);

  return (
    <Box
      display="flex"
      gap={2}
      width="100%"
      mt={2}
      flexWrap="wrap"
      sx={{
        '& > *': {
          flex: '1 1 280px',
          maxWidth: '320px',
        },
      }}
    >
      {cards.map((card) =>
        card ? (
          <KpiCard
            key={card.key}
            title={card.title ?? ''}
            value={card.value ?? 0}
            icon={getIconNode(card.icon)}
            subtitle={card.subtitle ?? undefined}
            unit={card.unit as SectionUnitsEnum}
            unitPosition={card.unitPosition ?? undefined}
            roundToDecimal={card.roundToDecimal ?? undefined}
            sectionUnit={card.unit as SectionUnitsEnum}
            unitSystem={unitSystem}
          />
        ) : null
      )}
    </Box>
  );
};
